 function displayErrorFields(fields, errorBoxId, firstErrorField, returnList) {
  var errorBoxEle = document.getElementById(errorBoxId),
  		 list = '<ul>';
  for (i = 0; i < fields.length; i++) {
 	 list += '<li>' + fields[i] + '</li>';
  }
  list += '</ul>';
  if (returnList) {
 	 return list;
  }
  if (fields.length) {
 	 errorBoxEle.innerHTML += list;
   errorBoxEle.setAttribute('role', 'alert');
 	 window.location.hash = "#" + errorBoxId;
 	 if(firstErrorField != null){
 		 firstErrorField.focus();
 	 }
  }
 }